import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-google-places-autocomplete',
  templateUrl: './google-places-autocomplete.component.html',
  styleUrls: ['./google-places-autocomplete.component.scss'],
  standalone: false,
})
export class GooglePlacesAutocompleteComponent implements OnInit, OnDestroy {
  @Input() placeholder = 'Search for a location...';
  @Input() className = '';
  @Input() inputClassName = '';
  @Input() suggestionsClassName = '';
  @Output() placeSelect = new EventEmitter<google.maps.places.Place>();

  @ViewChild('input') inputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('suggestionsElement') suggestionsRef!: ElementRef<HTMLDivElement>;

  inputValue = '';
  suggestions: Array<google.maps.places.AutocompleteSuggestion> = [];
  showSuggestions = false;
  private unlistenClick: (() => void) | undefined;
  constructor(private renderer: Renderer2, private elementRef: ElementRef, private change: ChangeDetectorRef) { }
  ngOnInit() {
    // Use a small timeout to ensure the document is ready
    setTimeout(() => {
      this.unlistenClick = this.renderer.listen('document', 'click', (event: Event) => {
        if (!this.elementRef.nativeElement.contains(event.target)) {
          this.showSuggestions = false;
          this.suggestions = [];
          this.change.detectChanges();
        }
      });
    });
  }

  ngOnDestroy() {
    // Clean up the event listener when component is destroyed
    if (this.unlistenClick) {
      this.unlistenClick();
    }
  }
  async handleInputChange(value: string) {

    this.inputValue = value;
    if (!value.trim()) {
      this.suggestions = [];
      this.showSuggestions = false;
      this.change.detectChanges();
      return;
    }

    try {
      const sessionToken = new google.maps.places.AutocompleteSessionToken();
      const response =
        await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
          {
            input: value,
            sessionToken: sessionToken,
          }
        );
      this.suggestions = response.suggestions;
      this.showSuggestions = true;
      this.change.detectChanges();
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      this.suggestions = [];
      this.showSuggestions = false;
      this.change.detectChanges();
    }
  }

  handleInputClick(event: Event) {
    event.stopPropagation();
    this.showSuggestions = true;
    this.change.detectChanges();
  }


  async handleSuggestionClick(placeId: string) {
    try {
      event.stopPropagation();
      // const { Place } = (await google.maps.importLibrary(
      //   'places'
      // )) as google.maps.PlacesLibrary;

      const place = new google.maps.places.Place({
        id: placeId,
        requestedLanguage: 'en',
      });

      await place.fetchFields({
        fields: [
          'displayName',
          'formattedAddress',
          'location',
          'id',
        ],
      });
      this.placeSelect.emit(place);
      this.inputValue = place.formattedAddress || place.displayName || '';
      this.showSuggestions = false;
      this.suggestions = [];
      this.change.detectChanges();
    } catch (error) {
      console.error('Failed to fetch place details:', error);
    }
  }

  handleClickOutside(event: Event) {
    if (
      this.suggestionsRef?.nativeElement &&
      !this.suggestionsRef.nativeElement.contains(event.target as Node) &&
      this.inputRef?.nativeElement &&
      !this.inputRef.nativeElement.contains(event.target as Node)
    ) {
      this.showSuggestions = false;
      this.suggestions = [];
    }
    this.change.detectChanges();
  }
}
